import UserCardPopper from "@/components/communications-chat-components/UserCardPopper";
import { UserAvatarSx } from "@/components/communications-chat-components/utilStyles";
import UserAvatar from "@/components/lazo-ai-chat-components/Avatar";
import User from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/User";
import { LazoUser } from "@/models/LazoUser";
import LazoUserService from "@/services/LazoUserService";
import { Box } from "@mui/material";
import { useCallback, useMemo, useRef, useState } from "react";

type AvatarMentionProps = {
  user: User;
  userExternalId: string;
};

function AvatarMention(props: AvatarMentionProps) {
  const mentionRef = useRef<HTMLDivElement>(null);
  const [showUserCard, setShowUserCard] = useState<boolean>(false);
  const [user, setUser] = useState<LazoUser | null>(null);
  const [closeCardTimeoutHandle, setCloseCardTimeoutHandle] = useState<NodeJS.Timeout | null>(null);
  const [showCardTimeoutHandle, setShowCardTimeoutHandle] = useState<NodeJS.Timeout | null>(null);

  const fetchUser = useCallback(() => {
    if (user !== null) return;
    LazoUserService.getByCoreUserExternalId(props.userExternalId).then((r) => {
      r.onSuccess((c) => {
        setUser(c);
      });
    });
  }, [user]);

  const anchorEl = useMemo(() => {
    if (mentionRef.current) {
      return mentionRef.current;
    }
  }, [mentionRef.current]);

  function handleMentionMouseEnter() {
    if (showCardTimeoutHandle) return;
    const tHandle = setTimeout(() => {
      setShowUserCard(true);
      setShowCardTimeoutHandle(null);
    }, 300);
    setShowCardTimeoutHandle(tHandle);
  }

  function handleMentionMouseLeave() {
    if (showCardTimeoutHandle !== null) {
      clearTimeout(showCardTimeoutHandle);
      setShowCardTimeoutHandle(null);
    }
    if (closeCardTimeoutHandle !== null) return;
    const tHandle = setTimeout(() => {
      setShowUserCard(false);
      setCloseCardTimeoutHandle(null);
    }, 300);
    setCloseCardTimeoutHandle(tHandle);
  }

  return (
    <>
      <Box
        ref={mentionRef}
        onMouseEnter={() => {
          fetchUser();
          handleMentionMouseEnter();
        }}
        onMouseLeave={() => handleMentionMouseLeave()}
      >
        <UserAvatar
          sx={{
            ...UserAvatarSx,
            width: "56px",
            height: "56px",
            fontSize: "1.125rem",
            fontWeight: 500,
          }}
          user={
            {
              firstName: props.user.firstName,
              lastName: props.user.lastName,
            } as User
          }
        />
      </Box>
      <UserCardPopper
        anchorEl={anchorEl}
        lazoUser={user}
        open={showUserCard}
        setOpen={setShowUserCard}
        closeCardTimeoutHandle={closeCardTimeoutHandle}
        setCloseCardTimeoutHandle={setCloseCardTimeoutHandle}
      />
    </>
  );
}

export default AvatarMention;
